export default __webpack_public_path__ + "static/media/877.d93bf0a8.png";